import React, { useEffect, useState } from "react";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ButtonGroup,
  CancelButton,
  ConfirmButton,
  Row,
  ModalLabel,
  Select,
  SelectContainer,
  SelectList,
  SelectListItem,
  SelectListValue,
  SelectValue,
} from "./EditTagsModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import { ReactComponent as CheckedIcon } from "../../assets/icons/checked.svg";
import { ReactComponent as UncheckedIcon } from "../../assets/icons/unchecked.svg";
import { ReactComponent as ChevronIcon } from "../../assets/icons/chevron-down.svg";

const EditTagsModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedTags,
  tags = [],
  confirmButtonType = "primary",
  isLoading = false,
  isVipCreator,
}) => {
  const [isOpenSelect, setIsOpenSelect] = React.useState(false);

  const [tempSelectedTags, setTempSelectedTags] = useState(selectedTags);

  useLockBodyScroll(isOpen);

  useEffect(() => {
    if (selectedTags) {
      setTempSelectedTags(selectedTags);
    }
  }, [selectedTags]);

  const toggleSelect = () => {
    setIsOpenSelect((prev) => !prev);
  };

  const toggleTag = (tag) => {
    setTempSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag],
    );
  };

  const handleConfirm = () => {
    setIsOpenSelect(false);
    onConfirm(tempSelectedTags);
    onClose();
  };

  const handleCancel = () => {
    if (!isLoading) {
      setIsOpenSelect(false);
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>Edit Tags</ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>

          <SelectContainer>
            <ModalLabel>Select tags for your model</ModalLabel>

            <Select onClick={toggleSelect}>
              <SelectValue>
                {tempSelectedTags.length > 0
                  ? tempSelectedTags.join(", ")
                  : "Select tags"}
              </SelectValue>
              <ChevronIcon
                style={{
                  transform: isOpenSelect ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
              />
            </Select>

            {isOpenSelect && (
              <SelectList>
                {tags.map((tag) => {
                  const isChecked = tempSelectedTags.includes(tag.label);

                  return (
                    <SelectListItem
                      key={tag.id}
                      $disabled={
                        tempSelectedTags.length > (isVipCreator ? 5 : 4) &&
                        !isChecked
                      }
                      onClick={() => {
                        if (
                          tempSelectedTags.length < (isVipCreator ? 6 : 5) ||
                          isChecked
                        ) {
                          toggleTag(tag.label);
                        }
                      }}
                    >
                      <SelectListValue>{tag.label}</SelectListValue>
                      {isChecked ? <CheckedIcon /> : <UncheckedIcon />}
                    </SelectListItem>
                  );
                })}
              </SelectList>
            )}

            {/* <ModalMessage>You can edit tags every 14 days.</ModalMessage> */}
          </SelectContainer>

          <ButtonGroup>
            <ConfirmButton
              onClick={handleConfirm}
              $type={confirmButtonType}
              disabled={isLoading}
            >
              {isLoading ? (
                <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
              ) : (
                "Save"
              )}
            </ConfirmButton>
            <CancelButton onClick={handleCancel} disabled={isLoading}>
              Cancel
            </CancelButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default EditTagsModal;
